import { render, staticRenderFns } from "./ack-list.vue?vue&type=template&id=52f10a14"
import script from "./ack-list.vue?vue&type=script&lang=js"
export * from "./ack-list.vue?vue&type=script&lang=js"
import style0 from "./ack-list.vue?vue&type=style&index=0&id=52f10a14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports